module.exports = __webpack_public_path__ + "img/cn_pocket-11.13f7723.jpg";